export default function Proyek() {
  return (
    <div data-testid="page-proyek">
      <div className="pe-container pt-14 pb-16">
        <div className="pe-eyebrow">Proyek</div>
        <h1 className="mt-2 font-display font-bold text-3xl lg:text-4xl">Portofolio proyek Proper Energy</h1>
        <div className="mt-10 pe-card text-center">
          <p className="text-[color:var(--pe-text-muted)]">
            Konten studi kasus — foto proyek, konfigurasi terpasang, dan hasil terukur — sedang disiapkan bersama izin pemilik rumah.
            Angka pengukuran aktual akan disertai periode dan dasar perbandingan yang jelas, terpisah dari hasil simulasi.
          </p>
          <p className="mt-4 text-xs text-[color:var(--pe-text-muted)]">Status: menunggu materi dan persetujuan.</p>
        </div>
      </div>
    </div>
  );
}
